<sc-flex vertical fitHeight stretchContent>
  <div class="no-field-space">
    <form [formGroup]="form">
      <sc-flex>
        <sc-date-field-legacy formControlName="dateFrom" labelDictionaryKey="tmc-yard.ui.control.sac-client.moving-order-dialog.planned-transports-date-from">
        </sc-date-field-legacy>
        <sc-content-spacer></sc-content-spacer>
        <sc-date-field-legacy formControlName="dateUntil" labelDictionaryKey="tmc-yard.ui.control.sac-client.moving-order-dialog.planned-transports-date-to">
        </sc-date-field-legacy>
        <sc-content-spacer></sc-content-spacer>
        <sc-string-field formControlName="query" labelDictionaryKey="tmc-yard.ui.control.sac-client.moving-order-dialog.query"
          grow>
        </sc-string-field>
        <sc-content-spacer></sc-content-spacer>
        <sc-action-icon  (click)="refresh()" iconClass="fa-arrows-rotate"></sc-action-icon>
      </sc-flex>
    </form>
  </div>
  <sc-content-spacer vertical></sc-content-spacer>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      <table mat-table class="mat-table-selection" [dataSource]="dataSource" matSort matSortActive="{{sortColumn}}"
        (matSortChange)="sortChanged($event)" [matSortDirection]="sortDirection">

        <ng-container matColumnDef="noRecord">
          <td class="no-record" [colSpan]="this.columnsToDisplay.length" mat-footer-cell *matFooterCellDef>
            <sc-dictionary-label dictionaryKey="shared.tmc-table.nodata"></sc-dictionary-label>
          </td>
        </ng-container>

        <ng-container matColumnDef="hint">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.hint"></sc-dictionary-label>
          </th>
          <td mat-cell *matCellDef="let transport" [ngClass]="{'selected': selectedListEntry == transport}">
            <sc-flex>

              <app-transport-scope-icon [scope]="transport.transportScope" [type]="transport.transportType">
              </app-transport-scope-icon>

              @if (transport.useGlobalConnect) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-qrcode"></sc-icon>
              }

              @if (transport.useSms) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-message-sms"></sc-icon>
              }

              @if (transport.usePager) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-wifi"></sc-icon>
              }

              @if (transport.important) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-exclamation"></sc-icon>
              }

              @if (transport.urgent) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-truck-fast"></sc-icon>
              }

              @if (transport.intermitted) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-octagon-xmark"></sc-icon>
              }

              @if (transport.umbrueckung) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-shuffle"></sc-icon>
              }

              @if (transport.dangerousGoods) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
              }

              @if (transport.pendingTaskState !== PendingTaskState.NONE) {
                <sc-content-spacer [half]="true"></sc-content-spacer>
                <app-task-state-icon [state]="transport.pendingTaskState"></app-task-state-icon>
              }

            </sc-flex>
          </td>
        </ng-container>

        <ng-container matColumnDef="carrier">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.carrier"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.carrier}} </td>
        </ng-container>

        <ng-container matColumnDef="supplier">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.supplier"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.supplier}} </td>
        </ng-container>

        <ng-container matColumnDef="identifier">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.numberPlate"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.identifier}} </td>
        </ng-container>

        <ng-container matColumnDef="driver">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.driverName"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.driver}} </td>
        </ng-container>

        <ng-container matColumnDef="visitStatusDict">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.status"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}">
            @if (transport.status) {
              <sc-dictionary-label dictionaryKey="tmc-yard.common.enum.transport-processing-status.{{transport.status}}"></sc-dictionary-label>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="string1">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.string1"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.string1}} </td>
        </ng-container>

        <ng-container matColumnDef="string2">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.string2"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.string2}} </td>
        </ng-container>

        <ng-container matColumnDef="start">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.timing.start"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.start}} </td>
        </ng-container>

        <ng-container matColumnDef="reference">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.masterdata.firstLoadCarrier.orderReference"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.reference}} </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.options"></sc-dictionary-label>
          </th>
          <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}">
            {{transport.options}}
          </td>
        </ng-container>

        <ng-container matColumnDef="cargo">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.cargo"></sc-dictionary-label>
          </th>
          <td mat-cell class="multiple-lines text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.cargo}}
          </td>
        </ng-container>

        <ng-container matColumnDef="planningDate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.planning-date"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
          [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.planningDate}} </td>
        </ng-container>

        <ng-container matColumnDef="messagingResources">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>
            <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging-resources"></sc-dictionary-label>
          </th>
          <td mat-cell class="text-selection" *matCellDef="let transport"
            [ngClass]="{'selected': selectedListEntry == transport}"> {{transport.messagingResources}}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>

        <tr mat-row *matRowDef="let transport; columns: columnsToDisplay" [attr.data-transport-id]="transport.id"
        [ngClass]="{'selected': selectedListEntry == transport}" (click)="toggleSelection(transport)"></tr>

        <tr [class.hide]="dataSource.data.length > 0" mat-footer-row *matFooterRowDef="['noRecord']"></tr>
      </table>
    </sc-scroll-pane>
  </sc-flex-fitting-content>
</sc-flex>
